module.exports = __webpack_public_path__ + "static/logo-214db81a6dd4e22086e27d21ee14bf77.png";